var waitFor = require("../utils/waitFor");

waitFor(".nav-primary", function () {
  let $toggleSearch = $(".js-toggle-search");
  let $menuOpen = $(".js-menu-open");
  let $menuClose = $(".js-menu-close");
  let openMenuClass = "has-open-menu";

  // menu
  $menuOpen.on("click", function () {
    $("body").addClass(openMenuClass);
    $toggleSearch.removeClass("is-open").addClass("is-closed");
    $(".search-overlay").removeClass("is-toggled");
  });

  $menuClose.on("click", function () {
    $("body").removeClass(openMenuClass);
  });

  // search
  $toggleSearch.on("click", function (e) {
    var $el = $(e.currentTarget);

    if ($el.hasClass("is-open")) {
      $el.removeClass("is-open").addClass("is-closed");
      $(".search-overlay").addClass("is-hiding").removeClass("is-toggled");
      setTimeout(function () {
        $(".search-overlay").removeClass("is-hiding");
      }, 1000);
    } else {
      $el.removeClass("is-closed").addClass("is-open");
      $(".search-overlay").addClass("is-toggled");
      $("body").removeClass(openMenuClass);
    }

    e.preventDefault();
  });

  // main nav dropdowns
  $(".nav-primary").on("mouseleave", ".main-menu-item", function (e) {
    $(e.currentTarget).addClass("is-hiding");

    clearTimeout($(e.currentTarget).data("hidingTO"));
    $(e.currentTarget).data(
      "hidingTO",
      setTimeout(function () {
        $(e.currentTarget).removeClass("is-hiding");
      }, 1000)
    );
  });
});
